<template>
  <transition name="fade">
    <div class="lightbox" :class="original ? 'original': ''" v-show="img && show">
      <span class="closer" @click="close">
        <i class="iconfont icon-close-fill font-xl"></i>
      </span>
      <i class="aligner"></i>
      <!--<img :src="img" alt="img" @click="toggle">-->
      <img :src="img" alt="img">
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LightBox',
  props: ['img'],
  data: () => ({
    original: false,
    show: false
  }),
  mounted () {
    var self = this
    self.$el.addEventListener('click', function (e) {
      var target = e.target
      if (target.tagName !== 'IMG') {
        self.close()
      }
    })
  },
  methods: {
    toggle () {
      this.original = !this.original
    },
    close () {
      var self = this
      self.original = false
      self.show = false
      setTimeout(function () {
        self.$emit('close')
      }, 500)

    }
  },
  watch: {
    img (val) {
      this.show = true
    }
  }
}
</script>

<style>
.lightbox {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: 98;
  background: #000;
  text-align: center;
  overflow: auto;
  white-space: nowrap;
}
.lightbox .aligner {
  vertical-align: middle;
  display: inline-block;
  height: 100%;
  margin: 0 -2px;
}
.lightbox .closer {
  position: fixed;
  cursor: pointer;
  color: #ddd;
  right: 1.5rem;
  top: 2rem;
}
.lightbox .closer:hover {
  color: #f1f1f1;
}
.lightbox img {
  max-height: 100%;
  max-width: 100%;
}
.lightbox.original img {
  max-height: initial;
  max-width: initial;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
